import { render, staticRenderFns } from "./IncidenceDetail.vue?vue&type=template&id=e406429a&"
import script from "./IncidenceDetail.vue?vue&type=script&lang=js&"
export * from "./IncidenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports